const list = {
    or: '或者',
    and: '和',
    separator: '，',
};
export default Object.freeze(list);
